import {AdminPagingModel} from "./AdminPagingModel";
import {Asset} from "../../entities/Asset";
import {AssetService} from "../../services/AssetService";
import {CustomFieldNameService} from "../../services/CustomFieldNameService";
import {PrintJobService} from "../../services/PrintJobService";
import {NotificationService} from "../../services/NotificationService";
import {ApplicationSettingService} from "../../services/ApplicationSettingService";
import {GridBookmarkService} from "../../services/GridBookmarkService";
import {Template} from "../../entities/Template";
import {PrintJob} from "../../entities/PrintJob";

export class AssetAdminPagingModel extends AdminPagingModel<Asset>{
    static $inject = ['$q','$uibModal','AssetService','CustomFieldNameService','PrintJobService','NotificationService','ApplicationSettingService','GridBookmarkService'];
    customColumnDefs:string[] = ["Name","Description","ActiveTagID","RfidTag","BatteryVolts","VTagLastSeen"];
    gotColumns:boolean = false;
    useMeters:boolean = true;
    constructor($q:ng.IQService,
                public modal:angular.ui.bootstrap.IModalService,
                public pagingService:AssetService,
                public customFieldNameService:CustomFieldNameService,
                public printjobService:PrintJobService,
                public notificationService:NotificationService,
                public applicationSettingService:ApplicationSettingService,
                gridBookmarkService:GridBookmarkService) {
        super($q, pagingService,notificationService, gridBookmarkService);
    }
    print(template:Template){
        var ids:number[] = this.selectedItems.map<number>((p)=> p.id);
        var printJobs:PrintJob[] = [];
        for (var i = 0; i < ids.length; i++){
            var printJob: PrintJob = new PrintJob(null, ids[i], "Asset", template.id, template.useWithService);
          printJobs.push(printJob);
        }
        this.printjobService.prints(printJobs).then(()=>{
            this.notificationService.notify("Print Jobs Scheduled successfully.");
        })
        .catch((exc)=>{
            this.notificationService.notifyError("Error printing", exc);
        });

    }
    handleCustomAction(actionName:string):ng.IPromise<void>{
        var assets = this.selectedItems;
        switch(actionName){
            case "Batch Move":
                var modalInstance:angular.ui.bootstrap.IModalServiceInstance = this.modal.open({
                    animation: true,
                    template: require('../../../views/admin.batchmove.html').default,
                    controller: 'BatchMoveCtrl',
                    size: 'lg',
                    resolve: {
                        assets: function () {
                            return assets;
                        }
                    }
                });
                return modalInstance.result;
            default:
                return this.$q.resolve();
        }
    }
    getCustomActions():string[]{
        return ["Batch Print", "Batch Move", "Server Import", "Import", "Export"];
    }
    entityName():string{
        return "asset";
    }
    displayName():string{
        return "Assets";
    }
    transformItem(entity:Asset){
      if(!this.useMeters){
        var xStr = (entity.vTagX * 3.28084).toFixed(2);
        var yStr = (entity.vTagY * 3.28084).toFixed(2);
        entity.vTagX = Number(xStr);
        entity.vTagY = Number(yStr);
      }
    }
    getColumnDefs():ng.IPromise<void>{
      return this.$q.all([
        this.customFieldNameService.getAssetColumnDefs(),
        this.applicationSettingService.getCached()
      ]).then((data)=>{
        this.nameValuePairs = data[0];
        this.useMeters = data[1].useMeters;
        return this.$q.when();
      });
    }
}
